import { connect } from 'react-redux';

import {
  getOperatorName,
  getBookingUrl,
  getOperatorSearchUrl,
} from '../../store/selectors/package';
import { getIsLoggedUser } from '../../store/selectors/user';
import OperatorInfo from './OperatorInfo';

interface StateProps {
  operatorName: string;
  bookingUrl: string;
  operatorSearchUrl: string;
  isLoggedIn?: boolean;
}

const mapStateToProps = (state) => ({
  operatorName: getOperatorName(state),
  isLoggedIn: getIsLoggedUser(state),
  bookingUrl: getBookingUrl(state),
  operatorSearchUrl: getIsLoggedUser(state) && getOperatorSearchUrl(state),
});

export default connect<StateProps>(mapStateToProps)(OperatorInfo);
